// This optional code is used to register a service worker.
// register() is not called by default.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

const baseUrl = import.meta.env.BASE_URL || "/";
const normalizedBaseUrl = baseUrl.endsWith("/")
  ? baseUrl
  : `${baseUrl}/`;

export function register(config) {
  if (import.meta.env.PROD && "serviceWorker" in navigator) {
    // Ensure the service worker is hosted on the same origin.
    const publicUrl = new URL(baseUrl, window.location.href);

    if (publicUrl.origin !== window.location.origin) {
      console.log(
        `The publicUrl.origin does not match the window.location.origin. The service worker will do nothing.
         publicUrl origin = ${publicUrl.origin}. window.location.origin = ${window.location.origin}`
      );
      return;
    }

    window.addEventListener("load", async () => {
      if (isLocalhost) return; // keep your localhost guard

      // Always use the origin-root sw.js
      const swUrl = `${window.location.origin}${normalizedBaseUrl}sw.js`;

      // HEAD check to make sure the server returns JavaScript, not HTML.
      try {
        const res = await fetch(swUrl, {
          method: "HEAD",
          cache: "no-store",
          headers: { "Service-Worker": "script" },
        });

        const ct = (res.headers.get("content-type") || "").toLowerCase();
        const isJs =
          res.ok && (ct.includes("javascript") || ct.includes("ecmascript"));

        if (!isJs) {
          console.error(
            `[SW] Skipping registration: ${swUrl} returned status=${res.status}, content-type="${ct}".`
          );
          return;
        }
      } catch (e) {
        console.error(`[SW] Skipping registration: HEAD ${swUrl} failed.`, e);
        return;
      }

      // Register from the root, but scope it to the base URL
      registerValidSW(swUrl, config, { scope: baseUrl });
    });
  } else {
    console.log('No "serviceWorker" in navigator');
  }
}

export function registerValidSW(swUrl, config, options = { scope: "/" }) {
  navigator.serviceWorker
    .register(swUrl, options)
    .then(registration => {
      // Allow immediate activation of a newly installed worker
      function promptImmediateUpdate() {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: "SKIP_WAITING" });
        }
      }

      // Reload once the new SW takes control
      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });

      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener("statechange", () => {
          if (
            newWorker.state === "installed" &&
            navigator.serviceWorker.controller
          ) {
            // A new version is ready; activate it now
            promptImmediateUpdate();
            if (config?.onUpdate) config.onUpdate(registration);
          } else if (newWorker.state === "installed") {
            // First install
            if (config?.onSuccess) config.onSuccess(registration);
          }
        });
      });
    })
    .catch(error => {
      console.error("Error during service worker registration:", error);
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    const unregisterAll = async () => {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(
          registrations.map(registration => registration.unregister())
        );
      } catch (error) {
        console.error("Error during service worker cleanup:", error);
      }

      if ("caches" in window) {
        try {
          const cacheNames = await window.caches.keys();
          await Promise.all(cacheNames.map(name => window.caches.delete(name)));
        } catch (error) {
          console.error("Error clearing service worker caches:", error);
        }
      }
    };

    return unregisterAll();
  }

  return Promise.resolve();
}
